import { Injectable, NgZone } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarVerticalPosition
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar, private zone: NgZone, private router: Router) {}

  private verticalPosition: MatSnackBarVerticalPosition = 'top';

  warning(message: string) {
    this.openAutoDismiss(message);
  }

  warningWithAction(message: string, action_name: string, config: MatSnackBarConfig = {}) {
    return this.snackBar.open(message, action_name, this.getConfig(config));
  }

  notice(message: string) {
    this.openAutoDismiss(message);
  }

  showError(message: string): void {
    this.zone.run(() => {
      const snackRef = this.snackBar.open(
        message,
        'X',
        this.getConfig({
          verticalPosition: this.verticalPosition,
          panelClass: ['error']
        })
      );
      setTimeout(() => {
        snackRef.dismiss();
      }, 3000);
    });
  }

  private openAutoDismiss(message: string) {
    const snackRef = this.snackBar.open(message, undefined, this.getConfig());
    setTimeout(() => {
      snackRef.dismiss();
    }, 3000);
  }

  private getConfig(config: MatSnackBarConfig = {}): MatSnackBarConfig {
    const panelClass = [
      'notification-snack',
      ...(this.isTsdRoute ? ['notification-snack--tsd'] : []),
      ...(Array.isArray(config.panelClass)
        ? config.panelClass
        : config.panelClass
          ? [config.panelClass]
          : [])
    ];

    return {
      verticalPosition: this.isTsdRoute ? 'top' : config.verticalPosition,
      horizontalPosition: 'center',
      ...config,
      panelClass
    };
  }

  private get isTsdRoute() {
    const url = this.router.url || '';
    return (
      url.startsWith('/warehouse/scanner') ||
      url.startsWith('/docs/stocktaking-v2/scan') ||
      url.startsWith('/docs/moving/scan')
    );
  }
}
